import { createApi } from "@reduxjs/toolkit/query/react"
import { baseRestQueryResult as baseQuery } from "@/services/api";
import { ListResponse } from "@/types/response.type";
import { AuditLog } from "@/types/auditlog.type";

export const auditLogApi = createApi({
    reducerPath: "auditLogApi",
    baseQuery,
    endpoints: (builder) => ({
        getAuditLogs: builder.query<ListResponse<AuditLog>, {}>({
            query: (data) => ({url: "auditlog", params: data}),
            keepUnusedDataFor: 0,
            transformResponse: (rawResult: { data: ListResponse<AuditLog> }, meta) => {
                return rawResult.data
            },
        })
    })
});

export const {useGetAuditLogsQuery} = auditLogApi
